
import { BoxMonitorIndexPage } from "./index.box";
import { CloudMonitorIndexPage } from "./index.cloud";
import { DemoMonitorIndexPage } from "./index.demo";
import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class MonitorView extends mixin(environment.nexus, {
  box: BoxMonitorIndexPage,
  cloud: CloudMonitorIndexPage,
  demo: DemoMonitorIndexPage,
}) {
  [key: string]: any;
}
